export default "__VITE_ASSET__COUu1DNa__"